import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyReservationSearchService } from './../../../services/loyalty/loyalty-reservation-search.service';
import { SelectItem } from 'primeng/primeng';
import { Component, OnInit } from '@angular/core';
import { ReservationGiftStatus } from 'app/models/reservation-gift-status.model';
import { DataTableService } from 'app/modules/UIKit/components/dataTable/dataTable.service';
import { ReservationGiftStatusService } from 'app/services/loyalty/reservation-gift-status.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-loyalty-reservation-gift-status',
  templateUrl: './loyalty-reservation-gift-status.component.html',
  styleUrls: ['./loyalty-reservation-gift-status.component.css']
})
export class LoyaltyReservationGiftStatusComponent implements OnInit {

  public giftStatus: ReservationGiftStatus[];
  modalTitle = '';
  labels = {};
  statusList: SelectItem[];
  customFilter = KontableComponent.CustomFilter;

  constructor(
    public srvGiftStatus: ReservationGiftStatusService,
    public srvDataTable: DataTableService,
    public translate: TranslateService,
    private reservationSearchService: LoyaltyReservationSearchService
  ) { }

  reloadList(){
    this.statusList = [];
    this.giftStatus = [];
    this.srvGiftStatus.getAll().subscribe( res => {
      this.giftStatus = res;
    });
  }

  ngOnInit() {
    this.reloadList();
    this.translate.get([
      'common.all',
      'loyalty.ReservationGiftStatus_add_title',
      'loyalty.ReservationGiftStatus_edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['loyalty.ReservationGiftStatus_add_title'];
      this.labels['edit_title'] = res['loyalty.ReservationGiftStatus_edit_title'];
      this.statusList.push({label: res['common.all'], value: null});
      this.reservationSearchService.getStatusDefinition().subscribe(res => {
        res.forEach(status=> this.statusList.push({value: status.description, label: status.description}));
      })
    });
  }

  showDialog(data){
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvGiftStatus.giftStatusEdit = data == null ? new ReservationGiftStatus() : data;
  }

  delete(record){
    this.srvGiftStatus.delete(record).subscribe(() => {
      this.reloadList()
    });
  }

  recoverGiftStatus(record){
    this.srvGiftStatus.recover(record).subscribe(() => {
      this.reloadList()
    });
  }

  giftStatusAdd($event){
    this.srvGiftStatus.post($event).subscribe(() => {
      this.srvDataTable.get('reservation_gift_status').showDetail = false;
      this.srvGiftStatus.giftStatusEdit = null;
      this.reloadList()
    });
  }

  giftStatusUpdate($event){
    this.srvGiftStatus.put($event, this.srvGiftStatus.giftStatusEdit.id).subscribe(() => {
      this.srvDataTable.get('reservation_gift_status').showDetail = false;
      this.srvGiftStatus.giftStatusEdit = null;
      this.reloadList()
    }
  )
  }

  closeDialog(){
    this.srvGiftStatus.giftStatusEdit = null;
    this.reloadList()
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-gift-status/loyalty-reservation-gift-status.component.ts